// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyABqDkLuxvWgaf_hMiyoKh6t8gcTdoWEEA',
  authDomain: 'ss-admin-2ea2e.firebaseapp.com',
  projectId: 'ss-admin-2ea2e',
  storageBucket: 'ss-admin-2ea2e.firebasestorage.app',
  messagingSenderId: '850854367656',
  appId: '1:850854367656:web:ddf27f3d51b53881558d9d',
  measurementId: 'G-4J36TXY3B2',
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export let firebaseAuth;

try {
  firebaseAuth = getAuth(app);
} catch (error) {
  console.log({ error });
}
